export default {
  API_URL: process.env.VUE_APP_API_URL,
  GOOGLE_MAPS_URL: process.env.VUE_APP_GOOGLE_MAPS_URL,
  RECAPTCHA_URL: process.env.VUE_APP_RECAPTCHA_URL,
  RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  WALK_SCORE_URL: process.env.VUE_APP_WALK_SCORE_URL,
  WALK_SCORE_ID: process.env.VUE_APP_WALK_SCORE_ID,
  DOMAIN: process.env.VUE_APP_DOMAIN
}
